import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <Path
        d="M19.6365 10.0878H11.9868V6.78515C11.9868 5.66605 11.6059 4.54862 10.9415 3.71926C10.3133 2.93505 9.11827 2 6.9935 2C4.86873 2 3.67353 2.93505 3.04537 3.71941C2.38096 4.54877 2 5.6662 2 6.7853V7.56408C2 8.18945 2.52906 8.69646 3.18165 8.69646C3.83424 8.69646 4.3633 8.18945 4.3633 7.56408V6.7853C4.3633 6.16415 4.57143 5.53364 4.91994 5.0985C5.11972 4.84908 5.3707 4.6537 5.66611 4.51797C6.03116 4.35007 6.47767 4.26492 6.9935 4.26492C7.50933 4.26492 7.95584 4.35007 8.32089 4.51797C8.61614 4.65385 8.86728 4.84908 9.06706 5.0985C9.41557 5.53364 9.6237 6.1643 9.6237 6.7853V10.0879H9.31741C8.01224 10.0879 6.95411 11.1019 6.95411 12.3527V19.7352C6.95411 20.986 8.01224 22 9.31741 22H19.6367C20.9419 22 22 20.986 22 19.7352V12.3527C22 11.1019 20.9419 10.0879 19.6367 10.0879L19.6365 10.0878ZM16.0717 18.2601C16.1456 18.5242 15.9378 18.7836 15.6525 18.7836H13.3015C13.0161 18.7836 12.8085 18.5242 12.8822 18.2601L13.5179 15.9851C13.0799 15.6937 12.793 15.2083 12.793 14.6587C12.793 13.7676 13.5469 13.0451 14.4768 13.0451C15.4067 13.0451 16.1606 13.7676 16.1606 14.6587C16.1606 15.2084 15.8737 15.6938 15.4357 15.9851L16.0714 18.2601H16.0717Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconUnlocked'

export const IconUnlocked = memo(themed(Icon))
